const EMULATOR_BACKUP_COLLECTIONS = [
  "cardClubs",
  "clubPlayers",
  "scoreCards",
  "siteMembers",
];

const EMULATOR_BACKUP_FORMAT_VERSION = 1;
const EMULATOR_BACKUP_ENDPOINT_BASE = "/__local_admin__/emulator-backups";

function normalizeDatasetName(name) {
  return String(name ?? "")
    .trim()
    .replace(/\s+/g, " ");
}

function slugifyDatasetName(name) {
  const normalized = normalizeDatasetName(name)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return normalized.length > 0 ? normalized : "backup";
}

function buildBackupFileName(name) {
  return `${slugifyDatasetName(name)}.json`;
}

function validateEmulatorBackupPayload(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return { valid: false, message: "Backup payload must be an object." };
  }

  if (payload.formatVersion !== EMULATOR_BACKUP_FORMAT_VERSION) {
    return {
      valid: false,
      message: `Unsupported backup format version: ${payload.formatVersion}.`,
    };
  }

  if (
    !payload.collections ||
    typeof payload.collections !== "object" ||
    Array.isArray(payload.collections)
  ) {
    return { valid: false, message: "Backup payload is missing collections." };
  }

  for (const collectionName of EMULATOR_BACKUP_COLLECTIONS) {
    const entries = payload.collections[collectionName];

    if (!Array.isArray(entries)) {
      return {
        valid: false,
        message: `Collection ${collectionName} is missing or invalid.`,
      };
    }

    for (const entry of entries) {
      if (
        !entry ||
        typeof entry !== "object" ||
        Array.isArray(entry) ||
        typeof entry.id !== "string" ||
        entry.id.length === 0 ||
        !entry.data ||
        typeof entry.data !== "object" ||
        Array.isArray(entry.data)
      ) {
        return {
          valid: false,
          message: `Collection ${collectionName} contains an invalid document entry.`,
        };
      }
    }
  }

  return { valid: true };
}

export {
  buildBackupFileName,
  EMULATOR_BACKUP_COLLECTIONS,
  EMULATOR_BACKUP_ENDPOINT_BASE,
  EMULATOR_BACKUP_FORMAT_VERSION,
  normalizeDatasetName,
  slugifyDatasetName,
  validateEmulatorBackupPayload,
};
